export default __webpack_public_path__ + "static/media/audio.ab50c14c.png";